import { PropsWithChildren } from 'react';
import { LoadScript } from '@react-google-maps/api';

import { i18next } from '@packlink/translation-provider';
import { FullscreenSpinner } from '@components';

export const LoadScriptWrapper = ({ children }: PropsWithChildren<unknown>): JSX.Element => {
    const { apikey, version } = config.google.maps;

    return (
        <LoadScript
            version={version}
            region={i18next.language}
            language={i18next.language}
            googleMapsApiKey={apikey}
            loadingElement={<FullscreenSpinner />}
        >
            {children}
        </LoadScript>
    );
};
